import classnames from 'classnames/bind'
import PropTypes from 'prop-types'
import requiredIf from 'react-required-if'

import styles from './Button.module.css'

import Spinner from 'components/Spinner/Spinner'

let cx = classnames.bind(styles)

const Button = ({
  onClick,
  submit,
  buttonElement,
  primary = true,
  highlight,
  muted,
  solid,
  highlightPrimary,
  large,
  wide,
  fullheight,
  small,
  bold,
  inline,
  block,
  disabled,
  className,
  spinner,
  icon,
  iconOnLeft,
  textOnly,
  textOnlyMobile,
  centered,
  children,
  ref: buttonRef,
}) => {
  const class_name = className ? true : false
  const classes = cx({
    'btn-primary': primary && !textOnly,
    'btn-button': !textOnly,
    'btn-highlight': highlight,
    'btn-highlight-primary': highlightPrimary,
    'btn-solid': solid,
    'btn-muted': muted,
    'btn-inline': inline,
    'btn-block': block,
    'btn-large': large,
    'btn-wide': wide,
    'btn-full-height': fullheight,
    'btn-small': small,
    'btn-bold': bold,
    'btn-text-only': textOnly,
    'btn-text-only-mobile': textOnlyMobile,
    'btn-icon-left': iconOnLeft,
    'btn-spinning': spinner,
    'btn-disable': disabled,
    [`${className}`]: class_name,
  })

  const CenterWrapper = ({ children }) => {
    if (centered) {
      return <div className={styles['btn-centered']}>{children}</div>
    } else {
      return children
    }
  }

  const ButtonWrapper = ({ children }) => {
    if (submit) {
      return (
        <button type="submit" className={classes} disabled={disabled} ref={buttonRef}>
          {children}
        </button>
      )
    } else if (buttonElement) {
      return (
        <button type="button" className={classes} onClick={onClick} ref={buttonRef}>
          {children}
        </button>
      )
    } else {
      return (
        <div onClick={onClick} className={classes} ref={buttonRef}>
          {children}
        </div>
      )
    }
  }

  return (
    <CenterWrapper>
      <ButtonWrapper>
        <>
          {children}
          {icon && <div className={styles['btn-icon-wrapper']}>{icon}</div>}
          {spinner && (
            <div className={styles['btn-spinner']}>
              <Spinner visible={true} />
            </div>
          )}
        </>
      </ButtonWrapper>
    </CenterWrapper>
  )
}

Button.propTypes = {
  children: requiredIf(PropTypes.node, (props) => !props.icon),
  onClick: PropTypes.func,
  primary: PropTypes.bool,
  highlight: PropTypes.bool,
  large: PropTypes.bool,
  fullheight: PropTypes.bool,
  inline: PropTypes.bool,
  className: PropTypes.string,
  icon: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  iconOnLeft: PropTypes.bool,
}

Button.defaultProps = {
  primary: true,
}

export default Button
